import { TFunction } from "i18next";

export const handleDeleteEntity = async ({
  deleteFn,
  id,
  refetchFn,
  onBeforeDelete,
  onSuccess,
  onError,
  t,
}: {
  deleteFn: (id: string | number) => Promise<any>;
  id: string | number;
  refetchFn?: () => void | Promise<unknown>;
  onBeforeDelete?: () => void;
  onSuccess?: (title: string, message: string, response: any) => void;
  onError?: (message: string, error: any) => void;
  t: TFunction;
}) => {
  let response: any;
  let hasError = false;

  try {
    onBeforeDelete?.();

    response = await deleteFn(id);

    return response;
  } catch (error: any) {
    hasError = true;

    const errorTitle = error?.data?.title ?? error?.title ?? "Unknown error";
    const errorStatus = error?.data?.status ?? error?.status ?? "N/A";
    const errorDetail = error?.data?.detail ?? error?.detail ?? "N/A";

    onError?.(`${errorTitle} (${errorStatus})`, errorDetail);

    throw error;
  } finally {
    await refetchFn?.();

    if (!hasError) {
      if (response && Object.keys(response).length > 0) {
        const title =
          response?.title ?? t("MessageOperationCompletedSuceesuflly");

        const message =
          response?.message ?? t("EntityInactivatedSuccessfully");

        onSuccess?.(title, message, response);
      } else {
        onSuccess?.(
          t("MessageOperationCompletedSuceesuflly"),
          t("EntityInactivatedNoResponse"),
          null
        );
      }
    }
  }
};